import React, {useCallback, useEffect, useState} from "react";
import {userApi} from "../api/user-api";
import {Button, CloseButton, Dialog, Field, Input, InputGroup, Portal,} from "@chakra-ui/react"
import {useToast} from "@chakra-ui/toast";
import {useRecoilState} from "recoil";
import {showTfaCheck} from "./hooks/recoilData";
import {useDocumentVisibility} from "./hooks/DocumentVisibility";

export default function TfaCheck() {
    const [phrase, setPhrase] = useState("");
    const [showDialog, setShowDialog] = useState(false);
    const toast = useToast();
    const [tfa, setTfa] = useRecoilState(showTfaCheck);
    const [loading, setLoading] = useState(false);
    const isVisible = useDocumentVisibility();

    useEffect(() => {
        userApi
            .tfaState()
            .then((value) => {
                if (value && value.status)
                    setTfa(true);
            })
            .catch(error => {
                // setTfa(false);
            });
        return;
    }, [setTfa]);

    useEffect(() => {
        let timeout: any = null;
        const callSetShow = () => {
            setShowDialog(prev => {
                if (prev !== tfa)
                    setPhrase("");
                return tfa;
            });
        };
        if (!tfa) {
            callSetShow();
        } else {
            timeout = setTimeout(callSetShow, 1000);
        }

        if (!tfa)
            return;
        const checkTfa = () => {
            if (!isVisible)
                return;
            userApi
                .tfaState()
                .then((value) => {
                    setLoading(!(value && value.status));
                })
                .catch(error => {
                    // setTfa(false);
                });
        };
        checkTfa();
        const interval = setInterval(checkTfa, 5000);
        return () => {
            clearInterval(interval);
            if (timeout)
                clearTimeout(timeout);
        }
    }, [setTfa, tfa, isVisible]);

    const enter = useCallback(() => {
        userApi.tfaCheck(phrase)
            .then((value) => {
                if (value) {
                    setTfa(false);
                    toast({title: "TFA check", status: "success"});
                } else {
                    toast({title: "TFA check fail", status: "warning"});
                }
            })
            .catch((err) => {
                console.log("TFA check error status code is: " + err);
                // setTfa(false);
                toast({
                    title: "TFA check error",
                    description: `code: [${err}]`,
                    status: "error"
                });
            });
    }, [phrase, setTfa, toast]);

    const cancel = useCallback(() => {
        userApi.tfaCancel()
            .then((value) => {
                if (value) {
                    setTfa(false);
                    toast({title: "TFA cancel", status: "success"});
                }
            })
            .catch((err) => {
                console.log("TFA error status code is: " + err);
                toast({
                    title: "TFA cancel error",
                    description: `code: [${err}]`,
                    status: "error"
                });
            });
    }, [toast, setTfa]);

    return (
        <Dialog.Root open={showDialog} onOpenChange={(v: any) => {
            setShowDialog(v.open);
        }}>
            <Dialog.Trigger/>
            {/*<Dialog.Trigger asChild>*/}
            {/*    <Button variant="outline">*/}
            {/*        Open*/}
            {/*    </Button>*/}
            {/*</Dialog.Trigger>*/}
            <Portal>
                <Dialog.Backdrop/>
                <Dialog.Positioner>
                    <Dialog.Content>
                        <Dialog.Header>
                            <Dialog.Title>TFA Check</Dialog.Title>
                        </Dialog.Header>
                        <Dialog.Body>
                            <Field.Root>
                                <InputGroup>
                                    <Input type="text" placeholder="phrase"
                                           value={phrase}
                                           onChange={(it) => setPhrase(it.target.value)}/>
                                </InputGroup>
                            </Field.Root>
                        </Dialog.Body>
                        <Dialog.Footer>
                            <Dialog.ActionTrigger asChild>
                                <Button variant="outline" onClick={cancel} loading={loading}>Cancel</Button>
                            </Dialog.ActionTrigger>
                            <Button onClick={enter} loading={loading}>enter</Button>
                        </Dialog.Footer>
                        <Dialog.CloseTrigger asChild>
                            <CloseButton size="sm" onClick={cancel}/>
                        </Dialog.CloseTrigger>
                    </Dialog.Content>
                </Dialog.Positioner>
            </Portal>
        </Dialog.Root>
    );
}